export default {
  retrievedBuildingComplexes: (state, buildingComplexes) => {
    state.buildingComplexes = buildingComplexes;
  },
};
